import logEvent from 'analytics/logEvent';
import cn from 'classnames';
import React from 'react';

import Icon, { IconTypes } from 'components/basic/Icon';

import { useAppDispatch, useAppSelector } from 'redux-store';
import { openModal } from 'redux-store/slices/ui';

import TopBanner from '../../../../../complex/TopBanner';
import Logo from './logo.svg';

import s from './MobileMenu.module.scss';

export default function MobileMenu({
  hideTopBanner,
}: {
  hideTopBanner?: boolean;
}): JSX.Element {
  const dispatch = useAppDispatch();
  const { userAgent } = useAppSelector(state => state.ui);
  const isIOS = userAgent.os.name === 'iOS';
  const { appleOneLinkUrl, googleOneLinkUrl } = useAppSelector(
    state => state.experiments,
  );
  const isTopBannerShowed = useAppSelector(state => state.ui.isTopBannerShowed);

  return (
    <>
      <div
        className={cn(s.fixer, {
          [s.wide]: isTopBannerShowed,
        })}
      />
      <div className={s.contentWrapper}>
        <TopBanner hide={hideTopBanner} />
        <div className={s.wrapper}>
          <Logo className={s.logo} width="120" />
          <div className={s.rightWrapper}>
            <a
              className={s.link}
              onClick={(): void => {
                logEvent('Web_Site_Header_Store_Button_Clicked', {
                  type: `${isIOS ? 'appstore' : 'googleplay'}`,
                });
              }}
              href={isIOS ? appleOneLinkUrl : googleOneLinkUrl}
            >
              <Icon
                icon={
                  userAgent.os.name === 'iOS'
                    ? IconTypes.apple
                    : IconTypes.googlePlay
                }
                size={24}
              />
              <span className="ms-hidden">Get the app</span>
            </a>
            <Icon
              icon={IconTypes.burger}
              size={24}
              className={s.burger}
              onClick={(): void => {
                dispatch(openModal({ type: 'MainMenu' }));
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
